import React, { useState, useEffect } from 'react'
import MaterialTable from 'material-table'
import {
  TextField,
  Button,
  Select,
  MenuItem,
  Grid,
  IconButton,
} from '@material-ui/core'
import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'
import DeleteIcon from '@material-ui/icons/Delete'

import {
  getLlantas,
  getEnsambladoras,
  postLlanta,
  deleteLlanta,
  getTipos,
  getPermisosByUser,
} from '@auteco/services/sostenibilidadService'

import './SostenibilidadLlantasContainer.css'

const SostenibilidadLlantasContainer = () => {
  const [data, setData] = useState([])
  const [empresa, setEmpresa] = useState('')
  const [empresasList, setEmpresasList] = useState([])
  const [tiposList, setTiposList] = useState([])
  const [tipo, setTipo] = useState('')
  const [fecha, setFecha] = useState(null)
  const [cantidadLlantas, setCantidadLlantas] = useState(1000)
  const [permisos, setPermisos] = useState(0)
  const [isLoading, setIsLoading] = useState(false)


  const columns = [
    {
      title: 'Empresa',
      field: 'ensambladora_id',
      render: (rowData) => {
        const empresa = empresasList.find(
          (emp) => emp.id === rowData.ensambladora_id,
        )
        return empresa ? empresa.nombre : 'Desconocida'
      },
    },
    { title: 'Cantidad', field: 'cantidad', type: 'numeric' },
    { title: 'Fecha', field: 'fecha', type: 'date' },
    // buscar el tipo de llanta
    {
      title: 'Tipo',
      field: 'tipo_id',
      render: (rowData) => {
        const tipoLlanta = tiposList.find((t) => t.id === rowData.tipo_id)
        return tipoLlanta ? tipoLlanta.nombre : 'Desconocido'
      },
    },
    {
      title: 'Acción',
      field: 'accion',
      render: (rowData) => (
        <IconButton onClick={() => handleDeleteLlanta(rowData.id)}>
          <DeleteIcon />
        </IconButton>
      ),
    },

  ]

  function formatearFecha() {
    if (!fecha) return null
    const fechaFormat = new Date(fecha)
    const año = fechaFormat.getFullYear()
    const mes = (fechaFormat.getMonth() + 1).toString().padStart(2, '0')
    const dia = fechaFormat.getDate().toString().padStart(2, '0')
    return `${año}-${mes}-${dia}`
  }

  const handleAdd = async () => {
    setIsLoading(true)
    const response = await postLlanta({
      ensambladora_id: parseInt(empresa, 10),
      fecha: formatearFecha(),
      cantidad: cantidadLlantas,
      tipo_id: parseInt(tipo, 10),
    })

    if (response) {
      handleGetLlantas()
      setEmpresa('')
      setTipo('')
      setFecha(null)
      setCantidadLlantas(1000)
    }
    setIsLoading(false)
  }

  const handleGetLlantas = async () => {
    setIsLoading(true)
    const response = await getLlantas()
    if (response) {
      setData(response.llantas)
    }
    setIsLoading(false)
  }

  const handleGetEmpresas = async () => {
    setIsLoading(true)
    const { ensambladoras } = await getEnsambladoras()
    if (ensambladoras) {
      setEmpresasList(ensambladoras)
    }
    setIsLoading(false)
  }

  const handleDeleteLlanta = async (id) => {
    setIsLoading(true)
    const response = await deleteLlanta(id)
    if (response) {
      handleGetLlantas()
    }
    setIsLoading(false)
  }

  const handleGetTipos = async () => {
    setIsLoading(true)
    const response = await getTipos()
    setTiposList(response.tipos.filter((item) => item.tipo_id === '1'))
    if (response) {
      console.log(response)
    }
    setIsLoading(false)
  }
 
  const handleGetPermisosByUser = async () => {
    const response = await getPermisosByUser()
    if (response) {
      const llantasPermiso = response.permisos.find(permiso => permiso.nombre === 'Llantas');
      if (llantasPermiso) {
        setPermisos(parseInt(llantasPermiso.alcance, 10))
      }
    }
  }
  useEffect(() => {
    handleGetPermisosByUser()
    handleGetLlantas()
    handleGetEmpresas()
    handleGetTipos()
  }, [])

  return (
    <div>
       {permisos === 0 && <p>No tienes permisos para ver esta sección</p>}
      {permisos > 0 && (
        <div className={` ${isLoading ? 'my-loading' : ''}`}> 
        <MaterialTable
          title="Llantas"
          columns={columns}
          data={data}
          options={{
            headerStyle: {
              backgroundColor: '#f1f1f1',
              color: 'black',
              fontWeight: 'bold',
            },
          }}
        />
        </div>
      )}

      {permisos > 1 && (
        <div className={`container_baterias_form ${isLoading ? 'my-loading' : ''}`} >
          <h3>Registro Llantas</h3>
          <div className="form_baterias">
            <Grid
              container
              spacing={2}
              style={{ marginTop: '20px', maxWidth: '800px' }}
            >
              <Grid item xs={12}>
                <Select
                  value={empresa}
                  onChange={(e) => setEmpresa(e.target.value)}
                  displayEmpty
                  fullWidth
                >
                  <MenuItem value="" disabled>
                    Seleccionar Ensambladora
                  </MenuItem>
                  {empresasList &&
                    empresasList.map((empresa) => (
                      <MenuItem key={empresa.id} value={empresa.id}>
                        {empresa.nombre}
                      </MenuItem>
                    ))}
                </Select>
              </Grid>
              <Grid item xs={12}>
                <Select
                  value={tipo}
                  onChange={(e) => setTipo(e.target.value)}
                  displayEmpty
                  fullWidth
                >
                  <MenuItem value="" disabled>
                    Seleccionar Tipo
                  </MenuItem>
                  {tiposList &&
                    tiposList.map((tipoItem) => (
                      <MenuItem key={tipoItem.id} value={tipoItem.id}>
                        {tipoItem.nombre}
                      </MenuItem>
                    ))}
                </Select>
              </Grid>
              <Grid item xs={12}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id="fecha"
                    label="Fecha"
                    format="dd/MM/yyyy"
                    value={fecha}
                    onChange={setFecha}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    fullWidth
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Cantidad Llantas"
                  type="number"
                  value={cantidadLlantas}
                  onChange={(e) => setCantidadLlantas(e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAdd}
                  fullWidth
                  disabled={!empresa || !tipo || !fecha || !cantidadLlantas}
                >
                  Agregar
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      )}
    </div>
  )
}

export default SostenibilidadLlantasContainer
